if (!customElements.get('shipping-delivery-info')) {
  class ShippingDeliveryInfo extends HTMLElement {
    connectedCallback() {
      this.expressRow = this.querySelector('[data-express-row]');
      if (!this.expressRow) return;

      this.activeEl = this.expressRow.querySelector('[data-express-active]');
      this.expiredEl = this.expressRow.querySelector('[data-express-expired]');
      this.hourEl = this.expressRow.querySelector('.countdown-timer-hour');
      this.minEl = this.expressRow.querySelector('.countdown-timer-minute');
      this.secEl = this.expressRow.querySelector('.countdown-timer-sec');

      this.startTime = this.expressRow.dataset.startTime || '00:00';
      this.cutoffTime = this.expressRow.dataset.cutoffTime || '23:59';

      this.update();
      this.interval = setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    parseTimeToday(timeStr) {
      const parts = (timeStr || '').trim().split(':');
      const hours = parseInt(parts[0], 10) || 0;
      const minutes = parseInt(parts[1], 10) || 0;
      const date = new Date();
      date.setHours(hours, minutes, 0, 0);
      return date;
    }

    pad(num) {
      return String(num).padStart(2, '0');
    }

    showExpired() {
      if (this.activeEl) this.activeEl.hidden = true;
      if (this.expiredEl) this.expiredEl.hidden = false;
    }

    showActive(msRemaining) {
      if (this.activeEl) this.activeEl.hidden = false;
      if (this.expiredEl) this.expiredEl.hidden = true;

      const totalSec = Math.max(0, Math.floor(msRemaining / 1000));
      const hours = Math.floor(totalSec / 3600);
      const mins = Math.floor((totalSec % 3600) / 60);
      const secs = totalSec % 60;

      if (this.hourEl) this.hourEl.textContent = this.pad(hours);
      if (this.minEl) this.minEl.textContent = this.pad(mins);
      if (this.secEl) this.secEl.textContent = this.pad(secs);
    }

    update() {
      const now = new Date();
      const start = this.parseTimeToday(this.startTime);
      const cutoff = this.parseTimeToday(this.cutoffTime);

      if (now >= cutoff || now < start) {
        this.showExpired();
      } else {
        this.showActive(cutoff - now);
      }
    }
  }

  customElements.define('shipping-delivery-info', ShippingDeliveryInfo);
}
